import React from 'react'

export default function StoreFindercontent() {
  return (
    <div>
      <h2>Here all the content will come</h2>
    </div>
  )
}
